<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header title="我的推广" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div class="div main-content">
    	<div class="member-info item">
    		<div class="logo"><img class="img avatar"  v-bind:src="user.member_avatar+'?'+time"/></div>
    		<div class="name">会员名：{{user.member_name}}</div>
    	</div>
    	<!--<div class="money item mt-5">
    		<div class="title">
				待发放奖励
				<span @click='$router.push({name:"MemberInviterOrder"})' style="float: right;color:#ff0000">销售排名 > </span>
			</div>
    		<div class="money-wrapper mt-10">
    			<div class="money-item">
    				<div>{{inviter_member.week_direct_money}}</div>
    				<span>销售奖励</span>
    			</div>
    			<div class="money-item">
    				<div>{{inviter_member.low_carbon}}</div>
    				<span>低碳奖励</span>
    			</div>
    			<div class="money-item">
    				<div>{{inviter_member.admin_finance}}</div>
    				<span>管理奖励</span>
    			</div>
    		</div>
    	</div>-->
    	<div class="team item mt-5">
    		<div class="title"><span class="row"></span><span class="span">我的销售</span></div>
    		<div class="team-wrapper">
    			<div class="team-item">
    				<div class="num">{{inviter_member.texp}}</div>
    				<div class="link"></div>
    				<div class="text">推广业绩</div>
    			</div>
    			<div class="team-item">
    				<div class="num">{{inviter_member.hexp}}</div>
    				<div class="link"></div>
    				<div class="text">推广单量</div>
    			</div>
    			<div class="team-item">
    				<div class="num">{{inviter_member.tyj}}</div>
    				<div class="link"></div>
    				<div class="text">直推单量</div>
    			</div>
    		</div>
    	</div>
		<div class="team item mt-5">
			<div class="title"><span class="row"></span><span class="span">我的推广</span></div>
			<div class="team-wrapper">
				<div class="team-item">
					<div class="num">{{inviter_member.tema}}</div>
					<div class="link"></div>
					<div class="text">我的单量</div>
				</div>
				<div class="team-item">
					<div class="num">{{inviter_member.tema_a}}</div>
					<div class="link"></div>
					<div class="text">推广人数</div>
				</div>
				<div class="team-item">
					<div class="num">{{inviter_member.tema_s}}</div>
					<div class="link"></div>
					<div class="text">直推人数</div>
				</div>
			</div>
		</div>
    	<div class="div nav-wrapper mt-5">
    	  <!--<div class="div nav-item" @click='weixinVisible=true'>推广公众号</div>-->
    	  <div class="div nav-item" @click='posterVisible=true'>推广海报</div>
    	  <div class="div nav-item" @click='$router.push({name:"MemberInviterUser"})'>推广成员</div>    	  
    	</div>
    	<div class="btn" @click='shareVisible=true'>点击查看推广链接</div>      
    </div>
    <!--推广公众号-->
    <mt-popup v-model="weixinVisible" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header title="推广公众号" class="common-header">
          <mt-button slot="left" icon="back" @click="weixinVisible=false"></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content">
        <div class="refer_qrcode_weixin" v-if="refer_qrcode_weixin" >
          <img :src="refer_qrcode_weixin">
          <p>赶快去推广微信二维码吧!</p>
        </div>
        <p class="refer_qrcode_weixin_error" v-else>{{wx_error_msg}}</p>
      </div>
    </mt-popup>
    <!--推广海报-->
    <mt-popup v-model="posterVisible" position="right" class="common-popup-wrapper">
      <div class="common-header-wrap">
        <mt-header title="推广海报" class="common-header" style="box-shadow:none;background:#002b6f;color:#fff;">
          <mt-button slot="left" icon="back" @click="posterVisible=false"></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content">
        <img class="refer_qrcode_logo" :src="refer_qrcode_logo">
      </div>
    </mt-popup>
	<mt-popup v-model="shareVisible" position="bottom" class="common-popup-wrapper share-wrapper">
		<div class="div common-popup-content">
			<div class="div share-list">
				<div class="div share-item copy" @click="showLink()">复制</div>
			</div>	
		</div>
	</mt-popup>
		    
	<mt-popup v-model="copyVisible" class="copy-wrapper">
	  <div class="copy-wrapper">
		<div class="div title">您的浏览器不支持直接复制，请手动复制</div>
		<input type="text" :value="inviter_url" onfocus="this.select()" >
	  </div>
	</mt-popup>
  </div>
</template>

<script>
import { getInviterPoster } from '../../../api/memberInviter'
import { Toast } from 'mint-ui'
import { mapState } from 'vuex'
import flexLine from '../../flexLine'
import Clipboard from 'clipboard'
export default {
  components:{
  flexLine,
  },
  computed:{
    ...mapState({
        user: state => state.member.info
      })
	},
  data () {
    return {
      weixinVisible: false,
      posterVisible: false,
	  shareVisible:false,
	  copyVisible:false,
      inviter_url: '',
	  time:'',	
      refer_qrcode_logo: '',
      refer_qrcode_weixin: '',
      wx_error_msg: '',
      wrapperWidth: 0,
	  inviter_member:{}
    }
  },
  created () {
    getInviterPoster().then(res => {
      this.inviter_url = res.result.inviter_url
      this.refer_qrcode_logo = res.result.refer_qrcode_logo
      this.refer_qrcode_weixin = res.result.refer_qrcode_weixin
      this.wx_error_msg = res.result.wx_error_msg
	  this.inviter_member = res.result.inviter_member
    }).catch(function (error) {
      Toast(error.message)
    })
  },

  mounted () {
    this.wrapperWidth = document.documentElement.clientWidth - 20
	this.time = new Date().getTime()
  },
  methods: {
	showLink () {
	  let _this = this
	      _this.copyVisible = false
	  let clip = new Clipboard('.copy', {
	    text: () => {
	      return _this.inviter_url
	    }
	  })
	  //复制成功
	  clip.on('success', function() {
	    Toast('复制成功！')		
	    clip.destroy()
	  });
	  //复制失败
	  clip.on('error', function() {
	      Toast('复制失败,请手动复制！')
	      clip.destroy()
	  });		  
	},
  }
}
</script>
<style scoped lang="scss">
  .main-content{
  	  padding:0 $pageSpace;
  	  margin-top: $modelSpace;
  	  .item{
  		background-color: #fff;
  		border-radius: .5rem;
  		padding: $pageSpace;
  	  }
  	  .member-info{
  		  padding: $pageSpace;
  		  display: flex;
  		  align-items: center;
  		  background: -webkit-gradient(linear,left top,right top,from(#ecd8be),to(#dbb280));
  		  background: linear-gradient(90deg,#ecd8be,#dbb280);
  		  .logo{
  			  width: 3rem;
  			  height: 3rem;
  			  border-radius: 50%;
  			  overflow: hidden;
  			  img{
  				  width: 3rem;
  				  height: 3rem;
  			  }
  		  }
  		  .name{
  			  margin-left: .5rem;
  			  font-size: .7rem;
  			  color: #333;
  		  }
  	  }
  	  .money{
  		  .title{
  			  font-size: .7rem;
  			  color: #333;
  			  padding-bottom: .5rem;
  			  border-bottom: 1px dashed #dedede;
  		  }
  		  .money-wrapper{
  			  display: flex;
  			  .money-item{
  				  width: 33%;
  				  text-align: center;
  				  div{
  					  font-size: .7rem;
  					  color: #FB2630;
  				  }
  				  span{
  					  font-size: .6rem;
  					  color: #333;
  				  }
  			  }
  		  }
  	  }
  	  .team{
  		  .title{
  			  margin: 0 0 .75rem;
  			  position: relative;
  			  overflow: hidden;
  			  font-size: .8rem;
  			  font-weight: 700;
  			  color: #000;
  			  display: flex;
  			  justify-content: center;
  			  align-items: center;
  			  height: 1.5rem;
  			  .row{
  				  display: block;
  				   width: 6rem;
  				   height: .1rem;
  				   background-color: #000;
  			  }
  			  .span{
  				  width: 3.5rem;
  				  height: 1.25rem;
  				  text-align: center;
  				  padding: 0 .5rem;
  				  overflow: hidden;
  				  background-color: #fff;
  				  position: absolute;
  				  box-sizing: content-box;
  				}
  		  }
  		  .team-wrapper{
  			  display: flex;
  			  .team-item{
  				  flex: 1 1 0%;
  				  justify-content: center;
  				  color: #333;
  				  display: flex;
  				  flex-direction: column;
  				  padding: 1.2rem 0;
  				  align-items: center;
  				  background-color: #fcf3e7;
  				  margin:0 .25rem;
  				  .num{
  					  font-size: .8rem;
  					  font-weight: bold;
  				  }
  				  .link{
  					  height: .1rem;
  					  width: 1.1rem;
  					  background: -webkit-gradient(linear,left top,right top,from(#ecd8be),to(#dbb280));
  					  background: linear-gradient(90deg,#ecd8be,#dbb280);
  					  margin: .4rem 0;
  				  }
  				  .text{
  					  font-size: .6rem;
  				  }
  			  }
  		  }
  	  } 
  	  .nav-wrapper{
  		  display: flex;
  		  flex-wrap: wrap;
  		  .nav-item{
  			  width: 49%;
  			  margin-right: 2%;
  			  background-color: #FFFFFF;
  			  font-size: .6rem;
  			  text-align: center;
  			  border-radius: .25rem;
  			  margin-bottom: .5rem;
  			  padding: 1rem 0;
  			  
  		  }
  		  .nav-item:nth-child(2n){
  			  margin-right: 0;
  		  }
  	  }
  	  .btn{
  		  background-color: $primaryColor;
  		  color: #FFFFFF;
  		  font-size: .8rem;
  		  text-align: center;
  		  padding: .5rem 0;
  		  border-radius: 1.2rem;
  	  }
    }
    .share-list{
  	  display:flex;
  	  .share-item{
  		  height: 3rem;
  		  margin:1rem 0.8rem;
  		  width:2.5rem;
  		  padding-left:0;
  		  background: none;
  		  text-align:center;
  		  color: #333;
  		  font-size:$fontSize;
  	  }
  	  .share-item:before{
  		  font-family: "iconfont";
  		  content:'';
  		  display:block;
  		  border-radius:50%;
  		  width:2rem;
  		  height:2rem;
  		  line-height:2rem;
  		  text-align:center;
  		  font-size:1.2rem;
  		  color:#fff;
  		  background: red;
  		  margin:0 auto;
  		  margin-bottom:.25rem
  		}
  		.share-item.copy:before{
  			content:"\e64b";
  			background:#228B22;
  		} 
  	}
    .copy-wrapper{
  	  padding:1rem;
  	   input{
  		   height:1.5rem;
  		   line-height:1.5rem;
  		   padding:0 .2rem;
  		   width:12rem;
  		   border:1px solid #e1e1e1
  		}
  		.title{
  			font-size:$fontSize;
  			text-align: center;
  			margin-bottom:.5rem;
  		}
  	}
	.share-wrapper{
		height: 5rem;
		overflow: visible;
		.common-popup-content{
			top: 0;
		}
	}
  .inviter_url{font-size:$subFontSize;padding:.5rem;margin-left: .5rem;box-sizing:border-box}
  .refer_qrcode_weixin_error{font-size:$subFontSize;padding:.5rem;}
  .refer_qrcode_logo{width:100%;height:100%;}
  .refer_qrcode_weixin{text-align: center;margin-top:30%;}
  .refer_qrcode_weixin .img{width:8rem;height:8rem;}
  .refer_qrcode_weixin .p{line-height:2rem;font-size:$subFontSize;}
</style>
